class LocationFiltersService {

  constructor(ApiService, $q) {
    this.$q = $q;
    this.ApiService = ApiService;
  }

  get() {

    var data = [
      {
        name: "Entertainment",
        type: "Info",
        icon: "http://www.fillmurray.com/30/45"
      },
      {
        name: "Entertainment2",
        type: "Info",
        icon: "http://www.fillmurray.com/30/45"
      },
      {
        name: "Entertainment3",
        type: "Info",
        icon: "http://www.fillmurray.com/30/45"
      }
    ];

    return this.$q.when(data);

  }

}
LocationFiltersService.$inject = ['ApiService', '$q'];
export default LocationFiltersService;
